export default __webpack_public_path__ + "static/media/the-club-white.ea9e4021.svg";